module.exports = __webpack_public_path__ + "static/media/lensfinder.652264e1.png";